module.exports = __webpack_public_path__ + "static/profile-0891a11e437b91bbc4286f59afdbb80f.png";